// components/close-store
/* заявка на операцию с контейнером */
/* global DEBUG */
/* global Vue */

import template from './modal.jade'
import style    from './style.scss'
import Store    from 'Store'
import CntList  from 'components/cnt-list/component'
import StationsList  from 'components/stations-list/component'
import KonosFilesList  from 'components/konos-files-list/component'
import KonosFile  from 'components/konos-file/component';
import compareText from 'lib/sortArrays'
import parseUnixTime from 'lib/parseUnixTime'
import parseTime from 'lib/filters/parseUnixTime'
import parseKonosFileLink from 'lib/filters/parseKonosFileLink'
import datetimepicker from 'lib/datetimepicker'
import AutoCarrierExpList  from 'components/auto-carrier-exp-list/component'
//import onLinkClick   from 'lib/methods/onClick'

let name = 'close-store';
const store = new Store(name);


let url = 'api/CloseStore';

const carrierTypeSelect = {
    'ЖД': {'autocarriers': false, 'stations': true},
    'Авто': {'autocarriers': true, 'stations': false},
    'Расформ': {'autocarriers': false, 'stations': false},
    'Судно': {'autocarriers': false, 'stations': false}
};

const carrierTypes = [
    { text: 'ЖД', value: 1 },
    { text: 'Авто', value: 2 },
    { text: 'Расформ', value: 3 },
    { text: 'Судно', value: 4 }
];

function filterObject(arr, searchKey) {
    return arr.filter(obj => Object.keys(obj).some(key => obj[key].includes(searchKey)));
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index
}
function sortText(a,b) {
        let textA = a.toLowerCase(), textB = b.toLowerCase();
        if (textA < textB)
            return -1;
        if (textA > textB)
            return 1;
        return 0
}
function sortDate(a,b) {
    if (a.date_file < b.date_file)
        return -1;
    if (a.date_file > b.date_file)
        return 1;
    return 0
}
export default {
  name: name,
  template: template({style: style}),
    mixins: [parseTime, parseKonosFileLink],
  data: () => ({
    name: name,
    url: url,
    containers: null,
    stations:[],
    autocarriers:[],
    konosament_files:[],
    stations_show:false,
    autocarriers_show:false,
      carrier_type:[],
    carrierTypes: carrierTypes,
    konosaments:[],
    konosaments_cont:{},
    selected_konos_cont:[],
    show: true,
    errors: [],
    blockForm: false,
    profile_phone:null,
    profile_agreement:null,
    order:{},
    files:[],
    konosamentMessage:'Получение списка коносаментов...',
  }),

  ready() {
      datetimepicker(style);
      let now = new Date();
      let date_ready = now.getTime() / 1000;
      this.$set('date_ready', parseUnixTime(date_ready, 'dateVs'));
    // создадим экзепляр cnt-list и запросим
    // с сервера контейнеры за последние 30 дней
    let cntList = new Vue(CntList);
    // кинем евент с датами
    cntList.$emit('dates:cnt-list', {
      name: 'cnt-list',
      date_at: (new Date()).setDate((new Date()).getDate() - 30) / 1000,
      date_to: (new Date().getTime()) / 1000,
    });
    this.$set('cntList', cntList.$data);
//запросим список станций
    let stationsList = new Vue(StationsList);
    stationsList.$emit('stations:stations-list', {
      name: 'stations-list',
    });
      this.$set('stationsList', stationsList.$data);

    this.$set('profile_phone',store.$get('phone'));
    this.$set('profile_agreement',store.$get('agreement_number'));

  //список автоперевозчиков
      let autoCarrierList = new Vue(AutoCarrierExpList);
      autoCarrierList.$emit('auto-carrier:auto-carrier-exp-list', {
          name: 'auto-carrier-exp-list',
      });
      this.$set('autoCarrierList', autoCarrierList.$data)
  },

  methods: {
      chooseCarrier(e){
          let vm = e.targetVM;
          vm.carrierType = (vm.carrierType.length  === 0) ? 0 : vm.carrierType;
          vm.showStations = carrierTypeSelect[vm.carrierType].stations;
          vm.showAutoCarriers = carrierTypeSelect[vm.carrierType].autocarriers;
      },
      updateContList(e){
           if (this.konosament.length > 0) {
               this.selected_konos_cont = this.konosaments_cont[this.konosament];

               let konosFilesList = new Vue(KonosFilesList);
               konosFilesList.$emit('konos-files-list:konos-files-list', {
                   name: 'konos-files-list', number: this.konosament
               });
               this.$set('konosFilesList', konosFilesList.$data);

           } else this.selected_konos_cont = [];
      },

    submit(e) {
      e.preventDefault();
      let formData = new FormData(), self = this,
        autocarrier_name = filterObject(this.autocarriers, this.$get('autocarrier'))[0],
        station_name = filterObject(this.stations, this.$get('station_name'))[0];
      let data = $(this.$$.form).serializeArray();
      this.files.forEach((item, index)=>{
          formData.append('file'+index, item);
      });

      formData.append('name_expeditor', store.$get('name_expeditor') );
      formData.append('email', store.$get('email') );
      formData.append('phone', store.$get('phone') );
       $.each(data, function(i, field){
             /*if (field.name ==='autocarrier[]' && field.value.length > 0){
                 console.log(field.name, field.value);
                 field.value = filterObject(self.autocarriers, field.value)[0].text;
                 console.log(field.name, field.value);
             }
             if (field.name ==='city[]' && field.value.length > 0){
                 console.log(field.name, field.value);
                   field.value = filterObject(self.stations, field.value)[0].text;
                 console.log(field.name, field.value);
               }*/
             formData.append(field.name, field.value)
        });
      this.$set('data', formData);
      this.blockForm = true;
      store.$save(this);
       this.order = {};
      this.errors = ''
    },
    // обрабатываем файл из формы
    upload(e) {
      e.preventDefault();
     let file =  e.target.files[0];
      if (file.size > 10*1024*1024) {
        alert ('Размер вложения не должен превышать 10MB !')
      } else {
       this.files.push(file);
      }
    },
      deleteFile(e){
          let vm = e.targetVM;
          this.files.splice(vm.$index, 1)

      },
    // удалим контейнер
    remove(e) {
      let vm = e.targetVM;
      // вручную добавленные контейнеры удаляем,
      // скаченные - оставляем в выбираемых контейнерах
      if (vm.handle) {
        this.containers.splice(vm.$index, 1)
      } else {
        vm.selected = false
      }
    },
    // при закрытии окна возвратимся по истории назад и сбросим форму
    onClick(e) {
      e.preventDefault();
      this.$set('show', true);
      let from = this.$route.router._currentTransition.from.name || 'index';
      this.$route.router.go({ name: from });
        if (this.$get('blockForm')) {
            location.reload()
        }
    },

      addCntToList(e) {

      // add to list
      e.targetVM.selected = !e.targetVM.selected;
    },
  },

  watch: {
    // при получении данных о контейнерах отсортируем
    // контейнеры и создадим массив containers
    cntList: {
      handler() {
        let table = this.cntList.data.table,
        currentDate = (new Date().getTime()) / 1000;
          if (table && table.cnt_number === undefined) {
              this.containers = table
                  .filter(item => !item.cnt_closed)
                  .filter(item => !item.date_out)
                  .filter(item => item.date_pay)
                  .map(item => {
                      return {
                          number: item.number,
                          konos: item.konos,
                          vid_otpravka:item.vid_otpravka,
                          selected: false,


                      }
                  });
          } else this.containers = [];
          this.containers.forEach(item=>{
            if (this.konosaments_cont[item.konos] === undefined){
                this.konosaments_cont[item.konos] = [];
            }
            console.log(item.vid_otpravka.trim());
            console.log(item.number.trim());
              this.konosaments_cont[item.konos].push({
                  number: item.number.trim(),
                  selected:false,
                  carrierType:item.vid_otpravka.trim(),
                  showStations: (item.vid_otpravka.trim().length && carrierTypeSelect[item.vid_otpravka.trim()].stations === undefined) ? false: carrierTypeSelect[item.vid_otpravka.trim()].stations,
                  showAutoCarriers: (item.vid_otpravka.trim().length && carrierTypeSelect[item.vid_otpravka.trim()].autocarriers === undefined) ? false: carrierTypeSelect[item.vid_otpravka.trim()].autocarriers
              });
          });
          this.konosaments = this.containers
              .map(item=>{ return item.konos })
              .filter(item=>(item.length>0))
              .filter(onlyUnique)
              .sort(sortText);
          if (table){
              this.konosamentMessage = this.konosaments.length > 0 ? 'Выберите коносамент': 'Нет доступных коносаментов для выбора';
          }

      },
      deep: true,
    },
    stationsList: {
      handler() {
        let table = this.stationsList.data.table;
        if ( table ) {
          this.stations = table.map(  item => {
            return {
                value: item.code,
              text: item.name+' - '+item.road+' ('+item.code+')',
            }
          }).sort(compareText);
        }

      },
      deep: true,
    },
    autoCarrierList: {
          handler() {
              let table = this.autoCarrierList.data.table;
              if (table) {
                  this.autocarriers = table.map(item => {
                      return {
                          value: item.kod,
                          text: item.name,
                      }
                  }).sort(compareText);
              }
          },
          deep: true,
      },
      konosFilesList: {
          handler() {
              let table = this.konosFilesList.data.table;
              if (table) {
                  this.konosament_files = table.map(item => {
                      return {
                          date: item.date_file,
                          filename: item.file_name,
                          vid: item.vid_doc,
                          version: item.version,
                          link: '/file.php?u='+store.$get('login')+'&f='+item.file_name,
                          filelink: store.$get('login')+'/'+item.file_name,
                          loaded:false,
                      }
                  }).sort(compareText);
                  this.konosament_files.forEach(item => {
                  let konosFile = new Vue(KonosFile);
                  konosFile.$emit('konos-file:konos-file', {
                      name: 'konos-file',
                      number: this.konosament,
                      filename:item.filename,
                  });
                  this.$set('konosFile', konosFile.$data);
              })
              }
          },
          deep: true,
      },
      konosFile: {
          handler() {
              let data = this.konosFile.data;
              if (data && data.file) {
                  this.konosament_files.forEach(item => {
                      if (item.filelink === data.file && data.no_error) {
                          item.loaded = true;
                      }
                  })
              }
      },
      deep: true,
  },
  },

  events: {
    'fetchData:error': function() {
      this.$set('blockForm', false)
    },
    // если все ок, скроем поля формы
    'fetchData:ok': function() {
      this.$set('errors','');
      if (this.$get('data["errors"]') !== undefined){
        let arr = Object.keys(this.$get('data["errors"]')),
            arr1 = this.$get('data["errors"]'),
            message = ' Проверьте данные заявки:';
        arr.forEach(function(item, i) {
          message +='<br />'+(++i)+ '. '+arr1[item]
        });
        this.$set('errors', message);
        this.$set('blockForm', false);
        this.$set('show', true)
      }else {
        this.$set('errors', '');
        this.$set('blockForm', true);
        this.$set('show', false)
      }
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/close-store/index.js
 **/